import { useState } from "react";

const statuses = {
  Iniciado: "text-yellow-400 bg-yellow-100",
  Completado: "text-green-400 bg-green-400",
  Pendiente: "text-red-400 bg-red-400",
};

const environments = {
  Iniciado: "text-yellow-400 bg-yellow-400/10 ring-yellow-400/20",
  Pendiente: "text-red-400 bg-red-400/10 ring-red-400/30",
  Completado: "text-green-400 bg-green-400/10 ring-green-400/30",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Example({ data, contador }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 5;

  // Lógica de filtrado
  const filteredPacks = data.filter((pack) =>
    pack.Materia.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  // Lógica de paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPacks = filteredPacks.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredPacks.length / itemsPerPage);

  return (
    <div>
      <div className="mt-2 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="mx-auto max-w-2xl text-xl font-semibold leading-6 text-white lg:mx-0 lg:max-w-none text-center">
          Status de cursos
        </h2>
      </div>
      <ul className="">
        {currentPacks.map(
          (dat, idx) =>
            idx < contador && (
              <li
                key={idx}
                className="relative flex items-center space-x-4 py-2 mt-2 px-4 rounded-lg border border-grisMira"
              >
                <div className="min-w-0 flex-auto">
                  <div className="flex items-center gap-x-3">
                    <div
                      className={classNames(
                        statuses[dat.Estado],
                        "flex-none rounded-full p-1",
                      )}
                    >
                      <div className="size-2 rounded-full bg-current" />
                    </div>
                    <h2 className="min-w-0 text-sm font-semibold text-white">
                      <span className="truncate">{`${dat.Sede} `}</span>
                      <span className="text-gray-400">/</span>
                      <span className="whitespace-nowrap">{` ${dat.Grado} `}</span>
                      <span className="whitespace-nowrap">{` ${dat.IdSeccion} `}</span>
                      <span className="text-gray-400">/</span>
                      <span className="whitespace-nowrap">{` ${dat.Unidad}`}</span>
                      <span className="absolute inset-0" />
                    </h2>
                  </div>
                  <div className="mt-3 flex items-center gap-x-2.5 text-xs leading-5 text-gray-400">
                    <p className="truncate">{dat.Materia}</p>
                    <svg
                      viewBox="0 0 2 2"
                      className="h-1 w-1 flex-none fill-gray-300"
                    >
                      <circle r={1} cx={1} cy={1} />
                    </svg>
                    <p className="whitespace-nowrap">{dat.Actividad}</p>
                  </div>
                </div>
                <div
                  className={classNames(
                    environments[dat.Estado],
                    "flex-none rounded-full px-4 py-1 text-sm font-semibold ring-1 ring-inset",
                  )}
                >
                  {dat.Estado}
                </div>
              </li>
            ),
        )}
      </ul>
      {/* Paginación */}
      <div className="mt-4 flex justify-between items-center text-gray-300">
        <span className="text-gray-400">
          Página {currentPage} de {totalPages}
        </span>
        <div className="flex space-x-2">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="px-3 py-1 bg-gray-700 rounded disabled:opacity-50 hover:bg-gray-900"
          >
            Anterior
          </button>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className="px-3 py-1 bg-gray-700 rounded disabled:opacity-50 hover:bg-gray-900"
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
}
